import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { Observable, catchError, throwError } from 'rxjs';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    // console.log('[authInterceptor flow]');
    const authService = inject(AuthService);

    // Clone the request object, the query
    let clonedReq = req.clone();

    // Assuming token is in Local Storage.
    const jwt = authService.accessToken;

    /**
     * Request
     *
     * If the JWT has not expired, add the Authorization header.
     * The Authorization header will not be added if the JWT has expired.
     * This will force the server to return a "401 Unauthorized" response
     * for the protected API routes that the response Interceptor will receive
     * and remove the JWT from local storage while logging the user out of the app.
     */
    if (jwt) {
        if (!AuthUtils.isTokenExpired(jwt)) {
            /**
             * Add verification to know if token is already expired
             */
            clonedReq = req.clone({
                setHeaders: {
                    Authorization: `Bearer ${jwt}`,
                },
            });
        }
    } else {
        authService.signOut();
    }

    // console.log('[Auth Interceptor] JWT Available & Commented');
    // console.log(jwt);

    return next(clonedReq).pipe(
        catchError((error) => {
            // Catch "401 Unauthorized" responses
            if (error instanceof HttpErrorResponse && error.status === 401) {
                // Don't reload page if it's a 2FA authentication attempt
                if (!req.url.includes('get-token-sho')) {
                    /**
                     * Close session for 401 Unauthorized
                     */
                    authService.signOut();

                    // Reload the app
                    location.reload();
                }
            }
            // console.log('[Auth Interceptor Error] ', error);
            return throwError(error);
        })
    );

    /**
     * ======= Keep for development =======
     * If not token, just past the original request
     * Comment this line out to Firebase tests
     */
    // console.log(req);
    return next(req);
};
